// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".styled-border[data-v-869ccd10]{border:1px solid #e3e3e3;border-radius:8px;max-width:100vw;position:relative}.styled-border .styled-border-title[data-v-869ccd10]{background:#fff;left:14px;padding:0 4px;position:absolute;top:-12px}.green-border[data-v-869ccd10]{border:1px solid #53c05c;box-shadow:0 2px 2px 0 rgba(0,128,0,.14);color:#53c05c!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
